import { render } from "./revenues.vue?vue&type=template&id=e403d9b4&scoped=true"
import script from "./revenues.vue?vue&type=script&lang=js"
export * from "./revenues.vue?vue&type=script&lang=js"

import "./revenues.vue?vue&type=style&index=0&id=e403d9b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e403d9b4"]])

export default __exports__